import { push } from 'connected-react-router';
import { takeLatest, put } from 'redux-saga/effects';

import { Types } from './actions';

const navigateTo = function*(action) {
  const { route } = action;

  yield put(push(route));
};

const ResponsesSaga = function*() {
  yield takeLatest(Types.NAVIGATE_TO, navigateTo);
};

export default ResponsesSaga;



// WEBPACK FOOTER //
// ./src/redux/navigation/sagas.js